// src/api/teacherApi.js
import api from './axios';

// Sessions live des etudiants
export const getLiveSessions   = ()           => api.get('/teacher/sessions/live');
export const stopStudentSession = (resId)     => api.post('/teacher/sessions/' + resId + '/stop');

// Etudiants
export const getMyStudents     = (params={})  => api.get('/teacher/students', { params });
export const getStudentDetails = (userId)     => api.get('/teacher/students/' + userId);

// Grading
export const getClassGrading   = (params={})  => api.get('/teacher/grading', { params });
export const runGradingForStudent = (resId)   => api.post('/grading/run/' + resId);

// Stats classe
export const getClassStats     = (days=30)    => api.get('/teacher/stats?days=' + days);

// Feedback
export const sendFeedback = (userId, message) =>
  api.post('/teacher/feedback', { user_id: userId, message });
